import { Component, OnInit, TemplateRef } from '@angular/core';
import { CountryCityService } from '../country-city.service';
import { Router } from '@angular/router';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import {Sort} from '@angular/material/sort';
import {MatPaginator, MatSort, MatTableDataSource} from '@angular/material';


export interface Country {

  name: string;
}
export interface Countries {
  Name: string; 
}

@Component({
  selector: 'app-country-list',
  templateUrl: './country-list.component.html',
  styleUrls: ['./country-list.component.scss']
})
export class CountryListComponent implements OnInit {
  spin: boolean;
  sortValue = null;
  sortKey = null;
  modalRef: BsModalRef;
  message: string;


  countriesList: any [] ;
  sortedData: any [];



  constructor(
    private countryService: CountryCityService,
    private modalService: BsModalService,
    private router: Router,
    private toastr: ToastrService
  ) {
    //  this.sortedData = this.cities.slice();
    this.getAllCountries();
      // this.sortedData = this.countriesList.slice();
    // console.log(this.sortedData);

   }


   sortData(sort: Sort) {
    // const data = this.cities.slice();
    const data = this.countriesList.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'Name': return compare(a.Name, b.Name, isAsc);

        default: return 0;
      }
    });
  }







  getAllCountries() {
    this.countryService.getAllCountries().subscribe(Response => {
      this.countriesList = Response;
      if (this.countriesList == null) {
        this.spin = true;
      }
      console.log('Countries List', this.countriesList);
       this.sortedData = this.countriesList.slice();

    });
  }


  ngOnInit(): void {
    // this.getAllCountries();

  }

  city(id) {
    this.router.navigateByUrl('/country/city-list/' + id);
  }
  confirm(id): void {
    this.message = 'Confirmed!';
    this.countryService.DeleteCountry(id).subscribe(Response => {
      console.log('Response Delete API', Response);
      this.toastr.warning('Country deleted..');
      this.getAllCountries();
    });
    this.modalRef.hide();
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {class: 'modal-sm'});
 }

  decline(): void {
    this.message = 'Declined!';
    this.modalRef.hide();
  }

  CountryNavigation() {
    this.router.navigateByUrl('/country/add-country');
  }

  UpdateCountry(id) {
    this.router.navigateByUrl('country/update-country/' + id);
  }
}
function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
